import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** リース契約検索条件 */
enum ContractSearchCondition {
  allContracts = '1',
  contractPaymentCurrentMonth = '2',
  contractExpireCurrentMonth = '3',
  contractExpireCurrentMonthRegReLease = '4',
  contractExpireCurrentMonthNoRegReLease = '5',
  contractExpirationNotificationTarget = '6',
}

const nameConfig = {
  allContracts: new Map([
    [Locale.ja, '全ての契約'],
    [Locale.en, 'All Contracts'],
  ]),
  contractPaymentCurrentMonth: new Map([
    [Locale.ja, '当月に支払いがある契約'],
    [Locale.en, 'Contracts with a Payment in the Current Month'],
  ]),
  contractExpireCurrentMonth: new Map([
    [Locale.ja, '当月に満了する予定の契約'],
    [Locale.en, 'Contracts Due to Expire in the Current Month'],
  ]),
  contractExpireCurrentMonthRegReLease: new Map([
    [Locale.ja, '当月に満了する予定の契約のうち、再リース及び契約満了の登録がされている契約'],
    [Locale.en, 'Contracts Expire on the Current Month with Registered Re-lease and Contract Expiration'],
  ]),
  contractExpireCurrentMonthNoRegReLease: new Map([
    [Locale.ja, '当月に満了する予定の契約のうち、再リース及び契約満了の登録がされていない契約'],
    [Locale.en, 'Contracts Expire on the Current Month with No Registered Re-lease and Contract Expiration'],
  ]),
  contractExpirationNotificationTarget: new Map([
    [Locale.ja, '契約満了通知の対象と合致する契約'],
    [Locale.en, 'Contracts Matching Contract Expiration Notification Target'],
  ]),
};

const toEnum = rawValueToEnum(ContractSearchCondition, ContractSearchCondition.allContracts);
const toDisplay = enumToName(ContractSearchCondition, nameConfig);
const toDisplayWithPrefix = enumToName(ContractSearchCondition, nameConfig, { prefix: true });

export const contractSearchCondition = {
  enum: ContractSearchCondition,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ContractSearchCondition };
